<template>
    <b-modal v-if="!loading" id="vendor_form" ref="vendor_form"
             @hidden="resetForm" no-close-on-backdrop
             modal-class="modal-right modal-dialog-scrollable">

        <template v-slot:modal-title>
            {{ !edit ? 'Add New Vendor' : 'Edit Vendor' }}
        </template>

        <div class="d-flex flex-row mb-4">
            <span class="iconsminds-add mr-3 menu-icon-style"/>

            <p class="my-auto">
                Lorem ipsum dolor sit amet, consectetur adipisicing elit. Amet commodi
                dolores quod, repellendus similique sint.
            </p>
        </div>

        <b-form>
            <b-row>
                <b-colxx md="12">
                    <b-form-group label="Name" class="has-float-label">
                        <template v-slot:label>
                            <span>Name <sup><code>*</code></sup></span>
                        </template>

                        <b-form-input type="text" v-model="form.name" :class="{'border-danger': 'name' in errors}"
                                      @input="'name' in errors ? delete errors.name : ''"
                                      autocomplete="off" placeholder="Name"/>

                        <b-form-invalid-feedback :state="!'name' in errors"
                                                 v-text="'name' in errors ? errors.name[0] : ''"/>
                    </b-form-group>
                </b-colxx>

                <b-colxx md="12">
                    <b-form-group label="Address" class="has-float-label">
                        <template v-slot:label>
                            <span>Address <sup><code>*</code></sup></span>
                        </template>

                        <b-form-textarea v-model="form.address" :class="{'border-danger': 'address' in errors}"
                                         @input="'address' in errors ? delete errors.address : ''"
                                         autocomplete="off" placeholder="Address"/>

                        <b-form-invalid-feedback :state="!'address' in errors"
                                                 v-text="'address' in errors ? errors.address[0] : ''"/>
                    </b-form-group>
                </b-colxx>
            </b-row>
            <b-row>
                <b-colxx md="6">
                    <b-form-group label="City" class="has-float-label">
                        <template v-slot:label>
                            <span>City <sup><code>*</code></sup></span>
                        </template>

                        <b-form-input type="text" v-model="form.city" :class="{'border-danger': 'city' in errors}"
                                      @input="'city' in errors ? delete errors.city : ''"
                                      autocomplete="off" placeholder="City"/>

                        <b-form-invalid-feedback :state="!'city' in errors"
                                                 v-text="'city' in errors ? errors.city[0] : ''"/>
                    </b-form-group>
                </b-colxx>

                <b-colxx md="6">
                    <b-form-group label="State" class="has-float-label">
                        <template v-slot:label>
                            <span>State <sup><code>*</code></sup></span>
                        </template>

                        <v-select @input="updateState" v-model="selected.state" :options="states"
                                  :border-danger="'state_id' in errors"/>

                        <b-form-invalid-feedback :state="!'state_id' in errors"
                                                 v-text="'state_id' in errors ? errors.state_id[0] : ''"/>
                    </b-form-group>
                </b-colxx>
            </b-row>

            <b-row>
                <b-colxx md="6">
                    <b-form-group label="ZIP" class="has-float-label">
                        <template v-slot:label>
                            <span>ZIP <sup><code>*</code></sup></span>
                        </template>

                        <b-form-input type="text" v-mask="'#####'" placeholder="XXXXX"
                                      v-model="form.zip" :class="{'border-danger': 'zip' in errors}"
                                      @input="'zip' in errors ? delete errors.zip : ''" autocomplete="off"/>

                        <b-form-invalid-feedback :state="!'zip' in errors"
                                                 v-text="'zip' in errors ? errors.zip[0] : ''"/>
                    </b-form-group>
                </b-colxx>

                <b-colxx md="6">
                    <b-form-group label="Joining Date" class="has-float-label">
                        <template v-slot:label>
                            <span>Joining Date <sup><code>*</code></sup></span>
                        </template>

                        <v-date-picker
                            popover-align="right" popover-visibility="focus" mode="single"
                            v-model="datepicker.date" @input="'date' in errors ? delete errors.date : ''"
                            :input-props="{ class:'form-control' + ('date' in errors ? ' border-danger' : ''), placeholder: 'MM-DD-YYYY' }"/>


                        <b-form-invalid-feedback :state="!'date' in errors"
                                                 v-text="'date' in errors ? errors.date[0] : ''"/>
                    </b-form-group>
                </b-colxx>
            </b-row>

            <b-row>
                <b-colxx md="12">
                    <b-form-group label="Contact" class="has-float-label">
                        <template v-slot:label>
                            <span>Contact <sup><code>*</code></sup></span>
                        </template>

                        <b-form-input type="text" v-model="form.contact" :class="{'border-danger': 'contact' in errors}"
                                      @input="'contact' in errors ? delete errors.contact : ''"
                                      autocomplete="off" placeholder="Contact"/>

                        <b-form-invalid-feedback :state="!'contact' in errors"
                                                 v-text="'contact' in errors ? errors.contact[0] : ''"/>
                    </b-form-group>
                </b-colxx>
            </b-row>

            <b-row>
                <b-colxx md="12">
                    <b-form-group label="Email" class="has-float-label">
                        <template v-slot:label>
                            <span>Email <sup><code>*</code></sup></span>
                        </template>

                        <b-form-input type="text" v-model="form.email" :class="{'border-danger': 'email' in errors}"
                                      @input="'email' in errors ? delete errors.email : ''"
                                      autocomplete="off" placeholder="Email"/>

                        <b-form-invalid-feedback :state="!'email' in errors"
                                                 v-text="'email' in errors ? errors.email[0] : ''"/>
                    </b-form-group>
                </b-colxx>
            </b-row>

            <b-row>
                <b-colxx md="6">
                    <b-form-group label="Phone" class="has-float-label">
                        <template v-slot:label>
                            <span>Phone <sup><code>*</code></sup></span>
                        </template>

                        <b-form-input type="text" v-mask="'(###) ###-####'" placeholder="(XXX) XXX-XXXX"
                                      v-model="form.phone" :class="{'border-danger': 'phone' in errors}"
                                      @input="'phone' in errors ? delete errors.phone : ''" autocomplete="off"/>

                        <b-form-invalid-feedback :state="!'phone' in errors"
                                                 v-text="'phone' in errors ? errors.phone[0] : ''"/>
                    </b-form-group>
                </b-colxx>

                <b-colxx md="6">
                    <b-form-group label="Fax" class="has-float-label">
                        <b-form-input type="text" v-mask="'(###) ###-####'" placeholder="(XXX) XXX-XXXX"
                                      v-model="form.fax" autocomplete="off"/>
                    </b-form-group>
                </b-colxx>
            </b-row>

            <b-row>
                <b-colxx md="12" class="mb-4">
                    <b-form-group label="Notes" class="has-float-label">
                        <b-form-textarea v-model="form.notes" rows="6" placeholder="Notes" autocomplete="off"/>
                    </b-form-group>
                </b-colxx>
            </b-row>
        </b-form>

        <template slot="modal-footer">
            <b-button variant="outline-secondary" @click="hideModal('vendor_form')" v-text="'Cancel'"/>

            <state-button v-if="!edit" variant="primary" :click="submitVendor">Submit</state-button>

            <state-button v-else variant="primary" :click="updateVendor">Update</state-button>
        </template>
    </b-modal>
</template>

<script>
    import { mapGetters } from "vuex";
    import StateButton from "../../../../components/Common/StateButton";
    import moment from "moment";

    export default {
        name: "VendorFormModal",

        components: {
            StateButton,
        },

        props: [
            'edit',
        ],

        data() {
            return {
                loading: true,
                datepicker: {
                    date: null,
                },
                selected: {
                    state: [],
                },
            }
        },

        computed: {
            ...mapGetters({
                form: 'getVendorForm',
                states: 'getSelectStates',
                errors: 'getVendorErrors',
            }),
        },

        watch: {
            form() {
                if (this.edit) {
                    this.datepicker.date = moment(this.form.date).toDate();

                    this.selected.state = this.form.select_state;
                }
            },
            'datepicker.date'(date) {
                if (moment(date).format('YYYY-MM-DD') === 'Invalid date') return this.form.date = null;
                this.form.date = moment(date).format('YYYY-MM-DD');
            }
        },

        mounted() {
            this.getFormData();
        },

        methods: {
            async getFormData() {
                await this.$store.dispatch('fetchSelectStates');

                return this.loading = false;
            },

            submitVendor() {
                return new Promise((success, fail) => {
                    this.$store.dispatch('submitVendor', this.form)
                        .then(response => {
                            setTimeout(() => {
                                success();

                                this.$emit('updated');

                                this.resetForm();

                                this.$notify('success filled', 'Success!', 'Added new vendor!', {
                                    duration: 4000,
                                    permanent: false
                                });

                                this.hideModal('vendor_form');
                            }, 2000);
                        })
                        .catch(error => {
                            setTimeout(() => {
                                fail();
                            }, 1000);
                        });
                })
            },

            updateVendor() {
                return new Promise((success, fail) => {
                    this.$store.dispatch('updateVendor', this.form)
                        .then(response => {
                            setTimeout(() => {
                                success();

                                this.$emit('updated');

                                this.resetForm();

                                this.$notify('success filled', 'Success!', 'Updated the vendor!', {
                                    duration: 4000,
                                    permanent: false
                                });

                                this.hideModal('vendor_form');
                            }, 2000);
                        })
                        .catch(error => {
                            setTimeout(() => {
                                fail();
                            }, 1000);
                        });
                })
            },

            updateState(field) {
                if (field) {
                    this.form.state_id = field.state_id;
                } else {
                    this.form.state_id = '';
                }
                'state_id' in this.errors ? delete this.errors.state_id : '';
            },

            hideModal(refname) {
                this.$refs[refname].hide();
            },

            resetForm() {
                this.$store.commit('setVendorForm');

                this.selected.state = [];
            },
        },
    }
</script>

<style scoped>

</style>
